import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { FinalProduct } from 'src/app/models/final_product.model';
import { FinalProductState, FinalProductStore } from './FinalProduct.store';

@Injectable({ providedIn: 'root' })
export class FinalProductQuery extends QueryEntity<FinalProductState, FinalProduct> {
  constructor(protected override store: FinalProductStore) {
    super(store);
  }
}